import React from 'react';

import get from 'lodash/get';

export default function createResultString(result, formatting) {
  return (
    <span>
      <span className="font-medium">
        {formatting.parts[0]
          .map((key) => {
            return get(result, key);
          })
          .join(' ')}
      </span>

      <span className="text-slate-600 dark:text-slate-400 group-hover:text-white">
        {formatting.parts.slice(1).map(([key, separator, formatter]) => {
          let value = get(result, key);

          if (key === `\n`) {
            return <br />;
          }

          if (!value) {
            return null;
          }

          if (formatter) {
            value = formatter(value);
          }

          return (
            <span key={key}>
              {separator || ''} {value}
            </span>
          );
        })}
      </span>
    </span>
  );
}
